import React, { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SHA256 from 'crypto-js/sha256';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg';
import './AdminLogin.css';

const AdminLogin = () => {
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!password.trim()) {
            alert('비밀번호를 입력해주세요.');
            return;
        }

        try {
            setLoading(true);

            // 비밀번호 SHA256 해싱
            const hashedPassword = SHA256(password).toString();

            // API로 비밀번호 확인
            const response = await fetch('https://mrlo.co.kr/api/verify-admin.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ password: hashedPassword })
            });

            const result = await response.json();

            if (result.success) {
                // 비밀번호 일치 시 관리자 모드로 게시판 이동
                alert('관리자 인증되었습니다.');
                navigate('/board?admin=true');
            } else {
                // 비밀번호 불일치 시
                alert(result.message || '비밀번호가 일치하지 않습니다.');
                setPassword('');
            }
        } catch (err) {
            alert('서버와 통신 중 오류가 발생했습니다.');
            console.error('Error verifying admin:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <div className="admin-login-section" style={{height:'100%'}}>
                <div className="container">
                    <div className="admin-login-wrapper">
                        <div className="admin-login-card">
                            <div className="admin-login-header">
                                <h2>관리자 로그인</h2>
                                <p>관리자 비밀번호를 입력하세요</p>
                            </div>

                            <form onSubmit={handleSubmit} className="admin-login-form">
                                <div className="form-group">
                                    <label htmlFor="password">비밀번호</label>
                                    <input
                                        type="password"
                                        id="password"
                                        className="form-control"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="관리자 비밀번호를 입력하세요"
                                        required
                                        autoFocus
                                    />
                                </div>

                                <div className="form-buttons">
                                    <button
                                        type="submit"
                                        className="btn-submit"
                                        disabled={loading}
                                    >
                                        {loading ? '확인 중...' : '로그인'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default AdminLogin;
